import { useAlbumPosts } from '@/utils/hooks/albums/useAlbumPosts';

import MediaSelectionSection from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/MediaSelectionSection';
// Components
import PostsList from '@/components/pages/albums/AlbumFunnelModal/ModalSteps/ManualStep/components/PostsList';

const PostListWrapper = () => {
    const {
        dataMedias,
        isLoadingInitialData,
        isLoadingMore,
        isLoadMore,
        loadMoreMedia,
        mutateMedias
    } = useAlbumPosts();

    return (
        <>
            <MediaSelectionSection dataMedias={dataMedias} />
            <PostsList
                dataMedias={dataMedias}
                isLoadingInitialData={isLoadingInitialData}
                isLoadingMore={isLoadingMore}
                isLoadMore={isLoadMore}
                loadMoreMedia={loadMoreMedia}
                mutateMedias={mutateMedias}
            />
        </>
    );
};

export default PostListWrapper;
